import { render } from "./MyCouponDetail.vue?vue&type=template&id=1114084e&scoped=true"
import script from "./MyCouponDetail.vue?vue&type=script&lang=js"
export * from "./MyCouponDetail.vue?vue&type=script&lang=js"

import "./MyCouponDetail.vue?vue&type=style&index=0&id=1114084e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1114084e"]])

export default __exports__